// Local-storage helpers for Setup Profile persistence (v8).
// Old keys (v1–v7 + legacy questionnaire keys) are auto-cleared on load.

const KEY = "food_bev_mrp_setup_profile_v8";
const LEGACY_KEYS = [
  "food_bev_mrp_questionnaire_v4",
  "fnb_mrp_questionnaire_v3",
  "fnb_mrp_questionnaire_v2",
  "fnb_mrp_questionnaire_v1",
  "food_bev_mrp_setup_profile_v5",
  "food_bev_mrp_setup_profile_v6",
  "food_bev_mrp_setup_profile_v7",
];

export function clearLegacyState() {
  try {
    LEGACY_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch {
    // ignore
  }
}

export function clearState() {
  try {
    localStorage.removeItem(KEY);
    clearLegacyState();
  } catch {
    // ignore
  }
}
